import React, { useState, useEffect, useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { supabase } from '../../../supabaseClient';
import { useConfirm } from '../../../hooks/useConfirm';
import Tutorial from '../../../components/Tutorial/Tutorial';
import { TUTORIALES } from '../../../constants/tutorialesConfig';

const Loader = ({ texto = 'Cargando...' }) => (
  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '60vh', gap: '20px' }}>
    <div style={{ position: 'relative', width: '56px', height: '56px' }}>
      <div style={{ position: 'absolute', inset: 0, borderRadius: '50%', border: '3px solid #0f172a' }} />
      <div style={{ position: 'absolute', inset: 0, borderRadius: '50%', border: '3px solid transparent', borderTopColor: '#00f2ff', animation: 'spin 0.9s linear infinite' }} />
      <div style={{ position: 'absolute', inset: '8px', borderRadius: '50%', border: '2px solid transparent', borderTopColor: '#a855f7', animation: 'spin 1.4s linear infinite reverse' }} />
    </div>
    <p style={{ color: '#f6f8fa', fontSize: '0.78rem', letterSpacing: '2px', textTransform: 'uppercase', margin: 0 }}>{texto}</p>
    <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
  </div>
);

const BANDERA_KEY = {
  'Mexico': 'mexico', 'South Africa': 'sudafrica', 'Korea Republic': 'corea',
  'Czechia': 'czechia', 'Canada': 'canada', 'Bosnia-Herzegovina': 'bosnia',
  'USA': 'usa', 'Paraguay': 'paraguay', 'Qatar': 'qatar', 'Switzerland': 'suiza',
  'Brazil': 'brasil', 'Morocco': 'marruecos', 'Haiti': 'haiti', 'Scotland': 'escocia',
  'Australia': 'australia', 'Turkey': 'turquia', 'Germany': 'alemania',
  'Curaçao': 'curacao', 'Netherlands': 'paises-bajos', 'Japan': 'japon',
  "Côte d'Ivoire": 'costa-marfil', 'Ecuador': 'ecuador', 'Sweden': 'suecia',
  'Tunisia': 'tunez', 'Spain': 'espana', 'Cabo Verde': 'cabo-verde',
  'Belgium': 'belgica', 'Egypt': 'egipto', 'Saudi Arabia': 'arabia-saudita',
  'Uruguay': 'uruguay', 'IR Iran': 'iran', 'New Zealand': 'nueva-zelanda',
  'France': 'francia', 'Senegal': 'senegal', 'Iraq': 'irak', 'Norway': 'noruega',
  'Argentina': 'argentina', 'Algeria': 'argelia', 'Austria': 'austria',
  'Jordan': 'jordania', 'Portugal': 'portugal', 'Congo DR': 'congo',
  'England': 'inglaterra', 'Croatia': 'croacia', 'Ghana': 'ghana',
  'Panama': 'panama', 'Uzbekistan': 'uzbekistan', 'Colombia': 'colombia',
  'México':'mexico','Sudáfrica':'sudafrica','Corea del Sur':'corea',
  'Chequia':'czechia','Canadá':'canada','Bosnia y Herzegovina':'bosnia','Bosnia Herzegovina':'bosnia',
  'Estados Unidos':'usa','Suiza':'suiza','Brasil':'brasil','Marruecos':'marruecos',
  'Haití':'haiti','Escocia':'escocia','Turquía':'turquia','Alemania':'alemania',
  'Países Bajos':'paises-bajos','Japón':'japon','Suecia':'suecia','España':'espana',
  'Bélgica':'belgica','Egipto':'egipto','Arabia Saudita':'arabia-saudita',
  'Irán':'iran','Nueva Zelanda':'nueva-zelanda','Francia':'francia',
  'Noruega':'noruega','Argelia':'argelia','Portugal':'portugal',
  'Inglaterra':'inglaterra','Croacia':'croacia','Panamá':'panama',
  'DR Congo':'congo','RD Congo':'congo','Túnez':'tunez','Costa de Marfil':'costa-marfil',
  'Cabo Verde':'cabo-verde','Curazao':'curacao','Jordania':'jordania',
  'Uzbekistán':'uzbekistan',
};

const EMOJIS = {
  'Mexico':'🇲🇽','South Africa':'🇿🇦','Korea Republic':'🇰🇷','Czechia':'🇨🇿',
  'Canada':'🇨🇦','Bosnia-Herzegovina':'🇧🇦','USA':'🇺🇸','Paraguay':'🇵🇾',
  'Qatar':'🇶🇦','Switzerland':'🇨🇭','Brazil':'🇧🇷','Morocco':'🇲🇦',
  'Haiti':'🇭🇹','Scotland':'🏴󠁧󠁢󠁳󠁣󠁴󠁿','Australia':'🇦🇺','Turkey':'🇹🇷',
  'Germany':'🇩🇪','Curaçao':'🇨🇼','Netherlands':'🇳🇱','Japan':'🇯🇵',
  "Côte d'Ivoire":'🇨🇮','Ecuador':'🇪🇨','Sweden':'🇸🇪','Tunisia':'🇹🇳',
  'Spain':'🇪🇸','Cabo Verde':'🇨🇻','Belgium':'🇧🇪','Egypt':'🇪🇬',
  'Saudi Arabia':'🇸🇦','Uruguay':'🇺🇾','IR Iran':'🇮🇷','New Zealand':'🇳🇿',
  'France':'🇫🇷','Senegal':'🇸🇳','Iraq':'🇮🇶','Norway':'🇳🇴',
  'Argentina':'🇦🇷','Algeria':'🇩🇿','Austria':'🇦🇹','Jordan':'🇯🇴',
  'Portugal':'🇵🇹','Congo DR':'🇨🇩','England':'🏴󠁧󠁢󠁥󠁮󠁧󠁿','Croatia':'🇭🇷',
  'Ghana':'🇬🇭','Panama':'🇵🇦','Uzbekistan':'🇺🇿','Colombia':'🇨🇴',
  'México':'🇲🇽','Sudáfrica':'🇿🇦','Corea del Sur':'🇰🇷','Chequia':'🇨🇿',
  'Canadá':'🇨🇦','Bosnia y Herzegovina':'🇧🇦','Bosnia Herzegovina':'🇧🇦','Estados Unidos':'🇺🇸','Paraguay':'🇵🇾',
  'Suiza':'🇨🇭','Brasil':'🇧🇷','Marruecos':'🇲🇦','Haití':'🇭🇹',
  'Escocia':'🏴󠁧󠁢󠁳󠁣󠁴󠁿','Turquía':'🇹🇷','Alemania':'🇩🇪',
  'Países Bajos':'🇳🇱','Japón':'🇯🇵','Ecuador':'🇪🇨','Suecia':'🇸🇪','España':'🇪🇸',
  'Bélgica':'🇧🇪','Egipto':'🇪🇬','Arabia Saudita':'🇸🇦','Uruguay':'🇺🇾','Irán':'🇮🇷',
  'Nueva Zelanda':'🇳🇿','Francia':'🇫🇷','Senegal':'🇸🇳','Iraq':'🇮🇶','Noruega':'🇳🇴',
  'Argelia':'🇩🇿','Austria':'🇦🇹','Portugal':'🇵🇹',
  'Inglaterra':'🏴󠁧󠁢󠁥󠁮󠁧󠁿','Croacia':'🇭🇷','Ghana':'🇬🇭','Panamá':'🇵🇦',
  'Colombia':'🇨🇴','DR Congo':'🇨🇩','RD Congo':'🇨🇩','Túnez':'🇹🇳','Costa de Marfil':'🇨🇮',
  'Cabo Verde':'🇨🇻','Curazao':'🇨🇼','Jordania':'🇯🇴','Uzbekistán':'🇺🇿',
};

const Bandera = ({ equipo, size = 30 }) => {
  const [imgError, setImgError] = useState(false);
  const key = BANDERA_KEY[equipo];
  if (!key || imgError)
    return <span style={{ fontSize: size * 0.65, lineHeight: 1, display: 'block', textAlign: 'center' }}>{EMOJIS[equipo] || '🏳️'}</span>;
  return (
    <img src={'/banderas/' + key + '.jpg'} alt={equipo} onError={() => setImgError(true)}
      style={{ width: size, height: Math.round(size * 0.67), objectFit: 'cover', borderRadius: 2, display: 'block', border: '1px solid rgba(255,255,255,0.08)' }} />
  );
};

const TZ = 'America/Argentina/Buenos_Aires';
const formatHora = (iso) => {
  if (!iso) return 'Por confirmar';
  return new Date(iso).toLocaleString('es-AR', {
    timeZone: TZ, weekday: 'short', day: '2-digit', month: '2-digit',
    hour: '2-digit', minute: '2-digit', hour12: false,
  }).replace(',', ' ·') + 'hs';
};

const COLORES = {
  exacto:    { border: '#3b82f6', color: '#3b82f6', label: '' },
  diferencia:{ border: '#00ff5e', color: '#00ff5e', label: '' },
  parcial:   { border: '#dcfe00', color: '#dcfe00', label: '' },
  error:     { border: '#ff4444', color: '#ff4444', label: '' },
  pendiente: { border: '#1e293b', color: '#64748b', label: '' },
};

function calcEstado(p, pron) {
  if (p.goles_local === null || !pron) return 'pendiente';
  const gl = p.goles_local, gv = p.goles_visitante;
  const pl = pron.goles_local, pv = pron.goles_visitante;
  if (pl === gl && pv === gv) return 'exacto';
  const dr = gl - gv, dp = pl - pv;
  const mismoGanador = (dr > 0 && dp > 0) || (dr < 0 && dp < 0) || (dr === 0 && dp === 0);
  if (!mismoGanador) return 'error';
  if (dr === dp) return 'diferencia';
  return 'parcial';
}

// ── Modal predicciones ────────────────────────────────────────────────────────
const ModalPredicciones = ({ partido, predicciones, onClose }) => {
  const contentRef = React.useRef(null);
  if (!partido) return null;
  const exportarImagen = async () => {
    if (!contentRef.current) return;
    try {
      // Usar html2canvas desde window si está disponible, o cargarlo dinámicamente
      let h2c = window.html2canvas;
      if (!h2c) {
        await new Promise((res, rej) => {
          const s = document.createElement('script');
          s.src = 'https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js';
          s.onload = res; s.onerror = rej;
          document.head.appendChild(s);
        });
        h2c = window.html2canvas;
      }
      const canvas = await h2c(contentRef.current, { backgroundColor: '#0a0f19', scale: 2, useCORS: true, logging: false });
      const url = canvas.toDataURL('image/png');
      // En mobile: intentar compartir via Web Share API
      if (navigator.share && navigator.canShare) {
        canvas.toBlob(async (blob) => {
          const file = new File([blob], `prode_${partido.equipo_local}_vs_${partido.equipo_visitante}.png`, { type: 'image/png' });
          if (navigator.canShare({ files: [file] })) {
            await navigator.share({ files: [file], title: `Prode: ${partido.equipo_local} vs ${partido.equipo_visitante}` });
          } else {
            const a = document.createElement('a'); a.href = url;
            a.download = `prode_${partido.equipo_local}_vs_${partido.equipo_visitante}.png`; a.click();
          }
        }, 'image/png');
      } else {
        const a = document.createElement('a'); a.href = url;
        a.download = `prode_${partido.equipo_local}_vs_${partido.equipo_visitante}.png`; a.click();
      }
    } catch(e) {
      console.error('Error exportando imagen:', e);
    }
  };
  return (
    <div onClick={onClose} style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)',
      backdropFilter: 'blur(6px)', zIndex: 9999,
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px',
    }}>
      <div ref={contentRef} onClick={e => e.stopPropagation()} style={{
        background: '#0a0f19', border: '1px solid #f59e0b44',
        borderRadius: '16px', padding: '24px', width: '100%', maxWidth: '420px',
        maxHeight: '80vh', display: 'flex', flexDirection: 'column', gap: '16px',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
            <Bandera equipo={partido.equipo_local} size={26} />
            <span style={{ color: '#e2e8f0', fontWeight: 'bold', fontSize: '0.9rem' }}>{partido.equipo_local}</span>
            <span style={{ color: '#f6f8fa', fontSize: '0.85rem' }}>vs</span>
            <span style={{ color: '#e2e8f0', fontWeight: 'bold', fontSize: '0.9rem' }}>{partido.equipo_visitante}</span>
            <Bandera equipo={partido.equipo_visitante} size={26} />
          </div>
          <div style={{ display:'flex', gap:'8px', alignItems:'center', flexShrink:0 }}>
            <button onClick={exportarImagen} title="Compartir" style={{ background:'#1e293b', border:'1px solid #334155', borderRadius:'6px', color:'#94a3b8', cursor:'pointer', fontSize:'0.75rem', padding:'4px 8px' }}>
              Compartir
            </button>
            <button onClick={onClose} style={{ background: 'none', border: 'none', color: '#f6f8fa', fontSize: '1.4rem', cursor: 'pointer', lineHeight: 1 }}>×</button>
          </div>
        </div>

        {partido.goles_local !== null && (
          <div style={{ textAlign: 'center', padding: '10px', background: '#080d14', borderRadius: '10px', border: '1px solid #1e293b' }}>
            <p style={{ color: '#f6f8fa', fontSize: '0.62rem', textTransform: 'uppercase', letterSpacing: '1px', margin: '0 0 4px' }}>Resultado final</p>
            <span style={{ color: '#fff', fontWeight: 'bold', fontSize: '1.6rem', letterSpacing: '4px' }}>
              {partido.goles_local} – {partido.goles_visitante}
            </span>
          </div>
        )}

        <div style={{ overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: '6px' }}>
          <p style={{ color: '#f6f8fa', fontSize: '0.65rem', textTransform: 'uppercase', letterSpacing: '1px', margin: 0 }}>
            Predicciones ({predicciones.length})
          </p>
          {predicciones.length === 0 && (
            <p style={{ color: '#f6f8fa', fontSize: '0.82rem', textAlign: 'center', padding: '20px 0' }}>
              Nadie cargó pronóstico para este partido
            </p>
          )}
          {predicciones.length > 0 && (() => {
            const grupos = [
              { key: 'empate',    label: 'Empate',                preds: [] },
              { key: 'local',     label: partido.equipo_local || 'Local',     preds: [] },
              { key: 'visitante', label: partido.equipo_visitante || 'Visitante', preds: [] },
            ];
            for (const pred of predicciones) {
              const gl = pred.goles_local, gv = pred.goles_visitante;
              if (gl === gv) grupos[0].preds.push(pred);
              else if (gl > gv) grupos[1].preds.push(pred);
              else grupos[2].preds.push(pred);
            }
            // Dentro de cada grupo: ordenar por goles totales asc, luego por goles_local asc
            for (const g of grupos) {
              g.preds.sort((a, b) => {
                const totalA = a.goles_local + a.goles_visitante;
                const totalB = b.goles_local + b.goles_visitante;
                if (totalA !== totalB) return totalA - totalB;
                return a.goles_local - b.goles_local;
              });
            }
            const items = [];
            for (const grupo of grupos) {
              if (grupo.preds.length === 0) continue;
              // Separador con label inline
              items.push(
                <div key={`sep-${grupo.key}`} style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: '6px 0 4px' }}>
                  <div style={{ flex: 1, height: '1px', background: '#1e293b' }} />
                  <span style={{ color: '#fff', fontSize: '0.58rem', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '1px', whiteSpace: 'nowrap' }}>{grupo.label}</span>
                  <div style={{ flex: 1, height: '1px', background: '#1e293b' }} />
                </div>
              );
              for (const pred of grupo.preds) {
                const estado = calcEstado(partido, pred);
                const est = COLORES[estado];
                items.push(
                  <div key={`${grupo.key}-${pred.nombre_usuario}`} style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                    padding: '4px 8px',
                    borderLeft: `2px solid ${estado !== 'pendiente' ? est.border : '#1e293b'}`,
                  }}>
                    <span style={{ color: '#e2e8f0', fontSize: '0.75rem', fontWeight: pred.esYo ? 'bold' : 'normal' }}>
                      {pred.nombre_usuario}
                      {pred.esYo && <span style={{ color: '#f59e0b', fontSize: '0.55rem', border: '1px solid #f59e0b44', borderRadius: '3px', padding: '0 4px', marginLeft: '5px' }}>vos</span>}
                    </span>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <span style={{ color: '#fff', fontWeight: 'bold', fontSize: '0.8rem', letterSpacing: '2px', fontVariantNumeric: 'tabular-nums' }}>
                        {pred.goles_local} – {pred.goles_visitante}
                      </span>
                      {estado !== 'pendiente' && (
                        <span style={{ color: est.color, fontSize: '0.6rem', fontWeight: 'bold', minWidth: '44px', textAlign: 'right' }}>
                          {est.label}
                        </span>
                      )}
                    </div>
                  </div>
                );
              }
            }
            return items;
          })()}
        </div>
      </div>
    </div>
  );
};

// ── Tarjeta de partido ────────────────────────────────────────────────────────
const PartidoCard = ({ partido, pronostico, onCambio, bloqueado, onVerPredicciones, ultimosResultados = {} }) => {
  const [local, setLocal]         = useState(pronostico?.goles_local ?? '');
  const [visitante, setVisitante] = useState(pronostico?.goles_visitante ?? '');
  const [ahora, setAhora]         = useState(() => new Date());

  useEffect(() => {
    setLocal(pronostico?.goles_local ?? '');
    setVisitante(pronostico?.goles_visitante ?? '');
  }, [pronostico]);

  // Actualizar "ahora" — cada segundo si falta menos de 2min, sino cada 30s
  useEffect(() => {
    if (!partido.cierre_pronosticos) return;
    const diff = new Date(partido.cierre_pronosticos) - new Date();
    const interval = diff < 120000 ? 1000 : 30000;
    const timer = setInterval(() => setAhora(new Date()), interval);
    return () => clearInterval(timer);
  }, [partido.cierre_pronosticos, ahora]);

  const esCerrado  = bloqueado || (partido.cierre_pronosticos && ahora >= new Date(partido.cierre_pronosticos));
  const tieneResult = partido.goles_local !== null && partido.goles_visitante !== null;
  const estado     = calcEstado(partido, pronostico);
  const est        = COLORES[estado];
  const esEnVivo   = partido.estado === 'en_vivo';
  const etiqueta   = partido.grupo ? `Grupo ${partido.grupo}` : (partido.ronda || '');

  // Countdown individual por partido
  let avisoPartido = null;
  if (!esCerrado && partido.cierre_pronosticos) {
    const diff = new Date(partido.cierre_pronosticos) - ahora;
    if (diff > 0 && diff <= 3600000) { // menos de 1 hora
      const m = Math.floor(diff / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      if (m < 1) {
        avisoPartido = { texto: `🔴 ¡Cierra en ${s}s!`, color: '#ef4444', bg: '#ef444415', border: '#ef444433' };
      } else if (m <= 10) {
        avisoPartido = { texto: `🟠 Cierra en ${m}m`, color: '#f97316', bg: '#f9731615', border: '#f9731633' };
      } else {
        avisoPartido = { texto: `⏱ Cierra en ${m}m`, color: '#f59e0b', bg: '#f59e0b10', border: '#f59e0b22' };
      }
    }
  }

  const handleLocal = (v) => { setLocal(v); onCambio(partido.id, v, visitante); };
  const handleVisitante = (v) => { setVisitante(v); onCambio(partido.id, local, v); };

  return (
    <div
      style={{
        background: '#080d14',
        border: `1px solid ${estado !== 'pendiente' ? est.border : esEnVivo ? '#22c55e44' : avisoPartido ? avisoPartido.border : '#1e293b'}`,
        borderRadius: '12px', padding: '14px 16px', transition: '0.2s',
        cursor: esCerrado ? 'pointer' : 'default',
      }}
      onClick={esCerrado ? onVerPredicciones : undefined}
    >
      {/* Aviso de cierre próximo */}
      {avisoPartido && (
        <div style={{ 
          background: avisoPartido.bg, border: `1px solid ${avisoPartido.border}`,
          borderRadius: '6px', padding: '4px 10px', marginBottom: '10px',
          color: avisoPartido.color, fontSize: '0.72rem', fontWeight: 'bold',
          textAlign: 'center', letterSpacing: '0.5px'
        }}>
          {avisoPartido.texto} — ¡Hacé tu pronóstico!
        </div>
      )}
      {!tieneResult && (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
          {etiqueta && <span style={{ background: '#1e293b', color: '#64748b', fontSize: '0.6rem', fontWeight: 'bold', padding: '2px 8px', borderRadius: '4px', textTransform: 'uppercase' }}>{etiqueta}</span>}
          {partido.cierre_pronosticos && (
            <span style={{ color: '#f7cb6b', fontSize: '0.6rem' }}>
              Cierre: {formatHora(partido.cierre_pronosticos)}
            </span>
          )}
        </div>
        <span style={{ color: esEnVivo ? '#22c55e' : '#f6f8fa', fontSize: '0.68rem', display: 'flex', alignItems: 'center', gap: '4px', marginLeft: 'auto' }}>
          {esEnVivo && <span style={{ width: 6, height: 6, borderRadius: '50%', background: '#22c55e', display: 'inline-block' }} />}
          {esEnVivo ? 'EN VIVO' : formatHora(partido.hora)}
        </span>
      </div>
      )}

      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flex: 1, justifyContent: 'flex-end', minWidth: 0 }}>
          <div style={{ textAlign: 'right', minWidth: 0 }}>
            <span style={{ color: '#e2e8f0', fontWeight: 'bold', fontSize: '0.88rem', lineHeight: 1.2, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '120px', display: 'block' }}>{partido.equipo_local || 'Por definir'}</span>
            {ultimosResultados[partido.equipo_local]?.gf !== undefined && (() => {
              const u = ultimosResultados[partido.equipo_local];
              const col = u.res === 'G' ? '#22c55e' : u.res === 'E' ? '#f5d800' : '#ef4444';
              return <span style={{ fontSize: '0.6rem', color: col, fontWeight: 'bold' }}> {u.gf}-{u.gc} vs {u.rival?.slice(0,3).toUpperCase()}</span>;
            })()}
          </div>
          <Bandera equipo={partido.equipo_local} size={28} />
        </div>

        <div style={{ flexShrink: 0, display: 'flex', alignItems: 'center', gap: '6px' }}>
          {tieneResult ? (
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <div style={{ background: '#0a0f19', borderRadius: '8px', padding: '6px 14px', border: `1px solid ${est.border}`, textAlign: 'center' }}>
                <span style={{ color: '#fff', fontWeight: 'bold', fontSize: '1.3rem', fontVariantNumeric: 'tabular-nums', letterSpacing: '3px' }}>
                  {partido.goles_local} – {partido.goles_visitante}
                </span>
                {estado !== 'pendiente' && (
                  <p style={{ color: est.color, fontSize: '0.58rem', margin: '2px 0 0', fontWeight: 'bold' }}>{est.label}</p>
                )}
              </div>
              {pronostico && (
                <div style={{ background: '#0a0f19', borderRadius: '8px', padding: '6px 10px', border: '1px solid #1e293b', textAlign: 'center' }}>
                  <p style={{ color: '#f6f8fa', fontSize: '0.52rem', margin: '0 0 2px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Tu pronóstico</p>
                  <span style={{ color: '#94a3b8', fontWeight: 'bold', fontSize: '0.95rem', fontVariantNumeric: 'tabular-nums', letterSpacing: '2px' }}>
                    {pronostico.goles_local} – {pronostico.goles_visitante}
                  </span>
                  {pronostico.puntos_ganados > 0 && (
                    <p style={{ color: '#22c55e', fontSize: '0.58rem', margin: '2px 0 0', fontWeight: 'bold' }}>+{pronostico.puntos_ganados} pts</p>
                  )}
                </div>
              )}
            </div>
          ) : esCerrado ? (
            pronostico ? (
              <div style={{ background: '#190c0a', borderRadius: '8px', padding: '6px 14px', border: '1px solid #f6f8fa', textAlign: 'center' }}>
                <p style={{ color: '#f6f8fa', fontSize: '0.52rem', margin: '0 0 2px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Tu pronóstico</p>
                <span style={{ color: '#64748b', fontWeight: 'bold', fontSize: '1.1rem', fontVariantNumeric: 'tabular-nums', letterSpacing: '2px' }}>
                  {pronostico.goles_local} – {pronostico.goles_visitante}
                </span>
              </div>
            ) : (
              <span style={{ color: '#f6f8fa', fontSize: '0.75rem', padding: '0 8px' }}>Sin pronóstico</span>
            )
          ) : (
            <>
              <input type="number" min="0" max="20" value={local} onChange={e => handleLocal(e.target.value)}
                onClick={e => e.stopPropagation()}
                style={{ width: '46px', height: '40px', textAlign: 'center', background: '#0a0f19', border: `1px solid ${local !== '' ? '#00f2ff66' : '#1e293b'}`, borderRadius: '8px', color: '#fff', fontSize: '1.2rem', fontWeight: 'bold' }} />
              <span style={{ color: '#f6f8fa', fontWeight: 'bold', fontSize: '1rem' }}>–</span>
              <input type="number" min="0" max="20" value={visitante} onChange={e => handleVisitante(e.target.value)}
                onClick={e => e.stopPropagation()}
                style={{ width: '46px', height: '40px', textAlign: 'center', background: '#0a0f19', border: `1px solid ${visitante !== '' ? '#00f2ff66' : '#1e293b'}`, borderRadius: '8px', color: '#fff', fontSize: '1.2rem', fontWeight: 'bold' }} />
            </>
          )}
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flex: 1, justifyContent: 'flex-start', minWidth: 0 }}>
          <Bandera equipo={partido.equipo_visitante} size={28} />
          <div style={{ minWidth: 0 }}>
            <span style={{ color: '#e2e8f0', fontWeight: 'bold', fontSize: '0.88rem', lineHeight: 1.2, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '120px', display: 'block' }}>{partido.equipo_visitante || 'Por definir'}</span>
            {ultimosResultados[partido.equipo_visitante]?.gf !== undefined && (() => {
              const u = ultimosResultados[partido.equipo_visitante];
              const col = u.res === 'G' ? '#22c55e' : u.res === 'E' ? '#f5d800' : '#ef4444';
              return <span style={{ fontSize: '0.6rem', color: col, fontWeight: 'bold' }}>{u.gf}-{u.gc} vs {u.rival?.slice(0,3).toUpperCase()}</span>;
            })()}
          </div>
        </div>
      </div>
    </div>
  );
};

// ── Detalle del torneo ────────────────────────────────────────────────────────
// ── Autocomplete para predicciones especiales ────────────────────────────────
const EspecialAutocomplete = ({ label, tipo, value, onChange, finalizado, valorReal }) => {
  const [query, setQuery] = React.useState(value || '');
  const [sugerencias, setSugerencias] = React.useState([]);
  const [abierto, setAbierto] = React.useState(false);
  const [cargando, setCargando] = React.useState(false);
  const refInput = React.useRef(null);
  const refDrop = React.useRef(null);

  React.useEffect(() => { setQuery(value || ''); }, [value]);

  React.useEffect(() => {
    const handler = (e) => {
      if (!refDrop.current?.contains(e.target) && !refInput.current?.contains(e.target)) setAbierto(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const buscar = async (q) => {
    setQuery(q);
    onChange(q);
    if (q.length < 2) { setSugerencias([]); setAbierto(false); return; }
    setCargando(true);
    if (tipo === 'pais') {
      // Búsqueda sin tildes usando la función normalizar de la DB
      const { data } = await supabase.rpc('buscar_paises_mundial', { q: q.toLowerCase() });
      setSugerencias((data || []).map(r => r.seleccion).slice(0, 8));
    } else {
      const { data } = await supabase.rpc('buscar_jugadores_mundial', { q: q.toLowerCase() });
      setSugerencias(data || []);
    }
    setCargando(false);
    setAbierto(true);
  };

  const elegir = (item) => {
    const val = tipo === 'pais' ? item : `${item.nombre} ${item.apellido}`.trim();
    setQuery(val); onChange(val); setSugerencias([]); setAbierto(false);
  };

  const acerto = value && valorReal && value.toLowerCase() === valorReal.toLowerCase();

  return (
    <div style={{ position: 'relative' }}>
      <label style={{ color: '#94a3b8', fontSize: '0.75rem', display: 'block', marginBottom: '4px' }}>{label}</label>
      {finalizado ? (
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <div style={{ flex: 1, background: '#0a0f19', border: '1px solid #1e293b', borderRadius: '6px', padding: '8px 12px', color: '#e2e8f0', fontSize: '0.9rem' }}>
            {value || <span style={{ color: '#f6f8fa' }}>—</span>}
          </div>
          <div style={{ color: acerto ? '#22c55e' : '#ef4444', fontSize: '0.8rem', fontWeight: 'bold', minWidth: '80px' }}>
            {acerto ? ' +15 pts' : ` ${valorReal || ''}`}
          </div>
        </div>
      ) : (
        <>
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px', background: '#0a0f19', border: `1px solid ${query ? '#f59e0b66' : '#1e293b'}`, borderRadius: '6px', padding: '2px 8px 2px 12px' }}>
            <input ref={refInput} value={query} onChange={e => buscar(e.target.value)}
              onFocus={() => query.length >= 2 && setAbierto(true)}
              placeholder={tipo === 'pais' ? 'Buscar país...' : 'Buscar jugador...'}
              style={{ flex: 1, background: 'transparent', border: 'none', outline: 'none', color: '#e2e8f0', fontSize: '0.9rem', padding: '6px 0' }} />
            {cargando && <span style={{ color: '#f6f8fa', fontSize: '0.7rem' }}>⏳</span>}
            {query && <button onClick={() => { setQuery(''); onChange(''); setSugerencias([]); }} style={{ background: 'none', border: 'none', color: '#f6f8fa', cursor: 'pointer', fontSize: '0.8rem', padding: '2px 4px' }}>✕</button>}
          </div>
          {abierto && sugerencias.length > 0 && (
            <div ref={refDrop} style={{ position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 999, background: '#0f172a', border: '1px solid #1e293b', borderRadius: '8px', marginTop: '4px', overflow: 'hidden', boxShadow: '0 8px 24px rgba(0,0,0,0.5)' }}>
              {sugerencias.map((item, i) => {
                const etiqueta = tipo === 'pais' ? item : `${item.nombre} ${item.apellido}`;
                const sub = tipo === 'jugador' ? item.seleccion : null;
                return (
                  <div key={i} onClick={() => elegir(item)}
                    style={{ padding: '9px 14px', cursor: 'pointer', borderBottom: i < sugerencias.length - 1 ? '1px solid #1e293b' : 'none', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
                    onMouseEnter={e => e.currentTarget.style.background = '#1e293b'}
                    onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                    <span style={{ color: '#e2e8f0', fontSize: '0.88rem' }}>{etiqueta}</span>
                    {sub && <span style={{ color: '#f6f8fa', fontSize: '0.72rem' }}>{sub}</span>}
                  </div>
                );
              })}
            </div>
          )}
          {abierto && sugerencias.length === 0 && query.length >= 2 && !cargando && (
            <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 999, background: '#0f172a', border: '1px solid #1e293b', borderRadius: '8px', marginTop: '4px', padding: '10px 14px', color: '#f6f8fa', fontSize: '0.82rem' }}>
              Sin resultados para "{query}"
            </div>
          )}
        </>
      )}
    </div>
  );
};

const ProdeDetalle = ({ torneoId, session, onVolver }) => {
  const [ultimosResultados, setUltimosResultados] = useState({});
  useEffect(() => {
    const cargarUltimos = async () => {
      const { data } = await supabase
        .from('mundial_partidos')
        .select('equipo_local, equipo_visitante, goles_local, goles_visitante')
        .not('goles_local', 'is', null)
        .order('hora', { ascending: false });
      if (!data) return;
      const u = {};
      data.forEach(p => {
        const gl = p.goles_local, gv = p.goles_visitante;
        if (!u[p.equipo_local])     u[p.equipo_local]     = { gf: gl, gc: gv, res: gl > gv ? 'G' : gl === gv ? 'E' : 'P', rival: p.equipo_visitante };
        if (!u[p.equipo_visitante]) u[p.equipo_visitante] = { gf: gv, gc: gl, res: gv > gl ? 'G' : gv === gl ? 'E' : 'P', rival: p.equipo_local };
      });
      setUltimosResultados(u);
    };
    cargarUltimos();
  }, []);

  const { confirmar, ConfirmModal } = useConfirm();
  const [torneo, setTorneo]               = useState(null);
  const [jornadas, setJornadas]           = useState([]);
  const [jornadaActiva, setJornadaActiva] = useState(null);
  const [partidos, setPartidos]           = useState([]);
  const [ahoraTick, setAhoraTick]         = useState(() => new Date());
  useEffect(() => {
    const t = setInterval(() => setAhoraTick(new Date()), 30000);
    return () => clearInterval(t);
  }, []);
  const [pronosticos, setPronosticos]     = useState({});
  const [tabla, setTabla]                 = useState([]);
  const [vista, setVista]                 = useState('partidos');
  const posicionesRef = React.useRef(null);
  const [predEspecial, setPredEspecial]   = useState({ campeon:'', subcampeon:'', max_goleador:'', max_asistidor:'' });
  const [guardandoPred, setGuardandoPred] = useState(false);
  const [predGuardada, setPredGuardada]   = useState(false);

  // Bloqueado si se cerró manualmente O si pasó la fecha límite — independiente de pronosticos_cerrados
  const predEspecialesBloqueadas = true; // Mundial arrancó el 11/06/2026 — bloqueo permanente
  const [loading, setLoading]             = useState(true);
  const [modalPartido, setModalPartido]   = useState(null);
  const [modalPredicciones, setModalPredicciones] = useState([]);

  // Banner de importar pronósticos desde otro prode
  const [otroProdeCon, setOtroProdecon]   = useState(null);  // { torneoId, nombre, count }
  const [especialesOtros, setEspecialesOtros] = useState([]);
  const [importando, setImportando]       = useState(false);
  const [importadoOk, setImportadoOk]     = useState(false);

  const abrirModalPredicciones = async (partido) => {
  setModalPartido(partido);
  const { data: prons } = await supabase
    .from('prode_pronosticos')
    .select('user_id, goles_local, goles_visitante, puntos_ganados')
    .eq('mundial_partido_id', partido.id)
    .eq('torneo_id', torneoId);

  const { data: participantes } = await supabase
    .from('prode_participantes')
    .select('user_id, nombre_usuario')
    .eq('torneo_id', torneoId);

  const lista = (prons || []).map(p => {
    const part = (participantes || []).find(x => x.user_id === p.user_id);
    return {
      nombre_usuario: part?.nombre_usuario || '?',
      goles_local: p.goles_local,
      goles_visitante: p.goles_visitante,
      puntos_ganados: p.puntos_ganados,
      esYo: p.user_id === session.user.id,
    };
  });
  lista.sort((a, b) => (b.esYo ? 1 : 0) - (a.esYo ? 1 : 0));
  setModalPredicciones(lista);
};

  const cargar = useCallback(async () => {
    const [{ data: t }, { data: part }] = await Promise.all([
      supabase.from('prode_torneos').select('*').eq('id', torneoId).single(),
      supabase.from('prode_participantes').select('*').eq('torneo_id', torneoId).order('puntos_totales', { ascending: false }),
    ]);
    setTorneo(t);

    // Calcular plenos (resultado exacto) por participante
    let tablaConPlenos = part || [];
    try {
      const { data: todosPartidos } = await supabase
        .from('mundial_partidos')
        .select('id, goles_local, goles_visitante')
        .not('goles_local', 'is', null);
      const partidosConResult = (todosPartidos || []);
      if (partidosConResult.length > 0) {
        const ids = partidosConResult.map(p => p.id);
        const { data: allProns } = await supabase
          .from('prode_pronosticos')
          .select('user_id, mundial_partido_id, goles_local, goles_visitante')
          .eq('torneo_id', torneoId)
          .in('mundial_partido_id', ids);
        const resultMap = Object.fromEntries(partidosConResult.map(p => [p.id, p]));
        const plenosMap = {};
        for (const pr of (allProns || [])) {
          const real = resultMap[pr.mundial_partido_id];
          if (real && pr.goles_local === real.goles_local && pr.goles_visitante === real.goles_visitante) {
            plenosMap[pr.user_id] = (plenosMap[pr.user_id] || 0) + 1;
          }
        }
        tablaConPlenos = (part || []).map(p => ({ ...p, plenos: plenosMap[p.user_id] || 0 }));
      }
    } catch (e) { /* silencioso */ }
    setTabla(tablaConPlenos);

    // Cargar predicciones especiales de todos los participantes
    const { data: todasEsp } = await supabase
      .from('prode_predicciones_especiales')
      .select('user_id, campeon, subcampeon, max_goleador, max_asistidor')
      .eq('torneo_id', torneoId);
    const nickMap = Object.fromEntries((tablaConPlenos || []).map(p => [p.user_id, p.nombre_usuario]));
    setEspecialesOtros((todasEsp || []).map(e => ({ ...e, nombre_usuario: nickMap[e.user_id] || '?' })));

    const { data: jornadasData } = await supabase
      .from('mundial_partidos').select('jornada, jornada_nombre').order('jornada');

    const jornadasUnicas = [];
    const vistas = new Set();
    (jornadasData || []).forEach(j => {
      if (!vistas.has(j.jornada)) {
        vistas.add(j.jornada);
        jornadasUnicas.push({ numero: j.jornada, nombre: j.jornada_nombre });
      }
    });
    setJornadas(jornadasUnicas);

    const ahora = new Date();
    const { data: proximoPartido } = await supabase
      .from('mundial_partidos').select('jornada, jornada_nombre')
      .gte('hora', ahora.toISOString()).order('hora').limit(1).single();

    const jornadaInicial = proximoPartido
      ? { numero: proximoPartido.jornada, nombre: proximoPartido.jornada_nombre }
      : jornadasUnicas[0];

    if (jornadaInicial) {
      setJornadaActiva(jornadaInicial);
      await cargarPartidosJornada(jornadaInicial.numero, torneoId, session.user.id);

      // Detectar si el usuario tiene pronósticos en OTRO prode de esta misma jornada
      const { data: otrosProdos } = await supabase
        .from('prode_participantes')
        .select('torneo_id, torneo:prode_torneos(nombre)')
        .eq('user_id', session.user.id)
        .neq('torneo_id', torneoId);

      if (otrosProdos?.length) {
        for (const op of otrosProdos) {
          const { data: prons } = await supabase
            .from('prode_pronosticos')
            .select('id', { count: 'exact', head: true })
            .eq('user_id', session.user.id)
            .eq('torneo_id', op.torneo_id)
            .not('goles_local', 'is', null);
          if ((prons?.length || 0) > 0 || true) {
            // Contar pronósticos
            const { count } = await supabase
              .from('prode_pronosticos')
              .select('id', { count: 'exact', head: true })
              .eq('user_id', session.user.id)
              .eq('torneo_id', op.torneo_id)
              .not('goles_local', 'is', null);
            if (count > 0) {
              setOtroProdecon({ torneoId: op.torneo_id, nombre: op.torneo?.nombre || 'otro prode', count });
              break; // solo mostramos el primero que encuentre
            }
          }
        }
      }
    }
    // Cargar predicción especial existente
    const { data: predEx } = await supabase.from('prode_predicciones_especiales')
      .select('*').eq('torneo_id', torneoId).eq('user_id', session.user.id).maybeSingle();
    if (predEx) {
      setPredEspecial({ campeon: predEx.campeon||'', subcampeon: predEx.subcampeon||'', max_goleador: predEx.max_goleador||'', max_asistidor: predEx.max_asistidor||'' });
      setPredGuardada(true);
    }

    setLoading(false);
  }, [torneoId, session.user.id]);

  const cargarPartidosJornada = async (numeroJornada, tId, userId) => {
    const { data: ps } = await supabase
      .from('mundial_partidos').select('*').eq('jornada', numeroJornada).order('hora');
    setPartidos(ps || []);

    const ids = (ps || []).map(p => p.id);
    if (ids.length) {
      const { data: prons } = await supabase
        .from('prode_pronosticos').select('*')
        .eq('torneo_id', tId).eq('user_id', userId).in('mundial_partido_id', ids);
      const map = {};
      (prons || []).forEach(p => { map[p.mundial_partido_id] = p; });
      setPronosticos(map);
    }
  };

  useEffect(() => { cargar(); }, [cargar]);

  const [pendientes, setPendientes] = useState({}); // { partidoId: { local, visitante } }
  const [guardandoTodos, setGuardandoTodos] = useState(false);
  const [guardadoOk, setGuardadoOk] = useState(false);
  const [mostrarJugados, setMostrarJugados] = useState(false);

  const importarPronosticos = async () => {
    if (!otroProdeCon) return;
    setImportando(true);
    // Traer todos los pronósticos del otro prode
    const { data: origen } = await supabase
      .from('prode_pronosticos')
      .select('mundial_partido_id, goles_local, goles_visitante')
      .eq('user_id', session.user.id)
      .eq('torneo_id', otroProdeCon.torneoId)
      .not('goles_local', 'is', null);

    if (!origen?.length) { setImportando(false); return; }

    // Upsert en este torneo
    const rows = origen.map(p => ({
      user_id: session.user.id,
      torneo_id: torneoId,
      mundial_partido_id: p.mundial_partido_id,
      goles_local: p.goles_local,
      goles_visitante: p.goles_visitante,
    }));
    await supabase.from('prode_pronosticos')
      .upsert(rows, { onConflict: 'user_id,torneo_id,mundial_partido_id' });

    // Recargar pronósticos en pantalla
    await cargarPartidosJornada(jornadaActiva.numero, torneoId, session.user.id);
    setImportando(false);
    setImportadoOk(true);
    setOtroProdecon(null);
    setTimeout(() => setImportadoOk(false), 3000);
  };

  const cambiarJornada = async (jornada) => {
    setJornadaActiva(jornada);
    setPendientes({});
    await cargarPartidosJornada(jornada.numero, torneoId, session.user.id);
  };

  const onCambioPartido = (partidoId, local, visitante) => {
    setPendientes(prev => ({ ...prev, [partidoId]: { local, visitante } }));
  };

  const guardarTodos = async () => {
    const entradas = Object.entries(pendientes).filter(([, v]) => v.local !== '' && v.visitante !== '');
    if (!entradas.length) return;
    setGuardandoTodos(true);
    for (const [partidoId, { local, visitante }] of entradas) {
      const golesL = parseInt(local), golesV = parseInt(visitante);
      const existing = pronosticos[partidoId];
      if (existing) {
        await supabase.from('prode_pronosticos')
          .update({ goles_local: golesL, goles_visitante: golesV }).eq('id', existing.id);
        setPronosticos(prev => ({ ...prev, [partidoId]: { ...existing, goles_local: golesL, goles_visitante: golesV } }));
      } else {
        const { data } = await supabase.from('prode_pronosticos').insert({
          mundial_partido_id: partidoId, user_id: session.user.id,
          torneo_id: torneoId, goles_local: golesL, goles_visitante: golesV,
        }).select().single();
        if (data) setPronosticos(prev => ({ ...prev, [partidoId]: data }));
      }
    }
    setPendientes({});
    setGuardandoTodos(false);
    setGuardadoOk(true);
    setTimeout(() => setGuardadoOk(false), 2500);
  };

  if (loading) return <Loader texto="Cargando prode..." />;

  const completados = partidos.filter(p => pronosticos[p.id]).length;
  const primerPartido = partidos[0];
  const bloqueado = torneo?.pronosticos_cerrados === true;

  let tiempoCierre = null;
  if (!bloqueado) {
    // Mostrar countdown del próximo partido que va a cerrar
    const proximoACerrar = partidos
      .filter(p => p.cierre_pronosticos && new Date(p.cierre_pronosticos) > new Date())
      .sort((a, b) => new Date(a.cierre_pronosticos) - new Date(b.cierre_pronosticos))[0];
    if (proximoACerrar) {
      const diff = new Date(proximoACerrar.cierre_pronosticos) - new Date();
      const d = Math.floor(diff / 86400000), h = Math.floor((diff % 86400000) / 3600000), m = Math.floor((diff % 3600000) / 60000);
      tiempoCierre = d > 0 ? `Primer cierre en ${d}d ${h}h` : h > 0 ? `Primer cierre en ${h}h ${m}m` : `Primer cierre en ${m}m`;
    }
  }

  return (
    <>
      {modalPartido && (
        <ModalPredicciones
          partido={modalPartido}
          predicciones={modalPredicciones}
          onClose={() => setModalPartido(null)}
        />
      )}

      <div style={{ maxWidth: '680px', margin: '0 auto', padding: '16px 20px', color: 'white' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
          <button onClick={onVolver} style={{ background: 'none', border: 'none', color: '#f6f8fa', cursor: 'pointer', fontSize: '1.2rem' }}>←</button>
          <div style={{ flex: 1, minWidth: 0, overflow: 'hidden' }}>
            <h2 style={{ margin: 0, fontSize: '0.95rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{torneo?.nombre}</h2>
            <p style={{ color: '#f6f8fa', margin: 0, fontSize: '0.72rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>Código: {torneo?.codigo_invitacion}</p>
          </div>
          <div style={{ display: 'flex', gap: '6px', flexShrink: 0 }}>
            {/* Copiar pronósticos → guarda en localStorage */}
            {Object.keys(pronosticos).length > 0 && (
              <button
                onClick={() => {
                  const data = {
                    pronosticos,
                    torneo_origen: torneo?.nombre,
                    copiado_en: new Date().toISOString(),
                  };
                  localStorage.setItem('dtxi_pronosticos_copiados', JSON.stringify(data));
                  alert(`✅ ${Object.keys(pronosticos).length} pronósticos copiados. Andá a otro prode y pegálos.`);
                }}
                style={{ background: '#1e293b', border: '1px solid #f6f8fa', borderRadius: '8px', padding: '6px 10px', color: '#94a3b8', fontSize: '0.75rem', cursor: 'pointer', whiteSpace: 'nowrap' }}
                title="Copiar mis pronósticos para pegar en otro prode"
              >
                Copiar
              </button>
            )}
            {/* Pegar pronósticos desde localStorage */}
            {!bloqueado && localStorage.getItem('dtxi_pronosticos_copiados') && (
              (() => {
                const raw = localStorage.getItem('dtxi_pronosticos_copiados');
                const saved = raw ? JSON.parse(raw) : null;
                const origen = saved?.torneo_origen;
                const cant = saved ? Object.keys(saved.pronosticos || {}).length : 0;
                if (!saved || !cant || origen === torneo?.nombre) return null;
                return (
                  <button
                    onClick={async () => {
                      const ok = await confirmar({ mensaje: `¿Pegar ${cant} pronósticos de "${origen}"?`, detalle: 'Solo se pegarán los partidos que todavía están abiertos.', textoOk: 'Pegar pronósticos' });
                      if (!ok) return;
                      const ahora = new Date();
                      let pegados = 0;
                      for (const [partidoId, pron] of Object.entries(saved.pronosticos)) {
                        const partido = partidos.find(p => p.id === partidoId);
                        if (!partido) continue;
                        const cerrado = bloqueado || (partido.cierre_pronosticos && ahora >= new Date(partido.cierre_pronosticos));
                        if (cerrado) continue;
                        if (pron.goles_local === null && pron.goles_visitante === null) continue;
                        await supabase.from('prode_pronosticos').upsert({
                          user_id: session.user.id,
                          torneo_id: torneo.id,
                          mundial_partido_id: partidoId,
                          goles_local: pron.goles_local,
                          goles_visitante: pron.goles_visitante,
                        }, { onConflict: 'user_id,torneo_id,mundial_partido_id' });
                        pegados++;
                      }
                      // Recargar pronósticos
                      const { data: nuevos } = await supabase.from('prode_pronosticos')
                        .select('*').eq('torneo_id', torneo.id).eq('user_id', session.user.id);
                      const mapa = {};
                      (nuevos || []).forEach(p => { mapa[p.mundial_partido_id] = p; });
                      setPronosticos(mapa);
                      alert(`✅ ${pegados} pronósticos pegados.`);
                    }}
                    style={{ background: '#00f2ff15', border: '1px solid #00f2ff44', borderRadius: '8px', padding: '6px 10px', color: '#00f2ff', fontSize: '0.75rem', cursor: 'pointer', whiteSpace: 'nowrap' }}
                    title={`Pegar ${cant} pronósticos de "${origen}"`}
                  >
                    Pegar ({cant})
                  </button>
                );
              })()
            )}
            <button
              onClick={() => {
                const link = `https://dtactico.com/unirse/${torneo?.codigo_invitacion}`;
                const texto = `¡Unite al Prode de DTXI! \n*${torneo?.nombre}*\nEntrá acá: ${link}`;
                window.open(`https://wa.me/?text=${encodeURIComponent(texto)}`, '_blank');
              }}
              style={{ background: '#25d36622', border: '1px solid #25d36644', borderRadius: '8px', padding: '6px 10px', color: '#25d366', fontSize: '0.78rem', fontWeight: 'bold', cursor: 'pointer', flexShrink: 0, whiteSpace: 'nowrap' }}
            >
              Invitar
            </button>
          </div>
        </div>

        <div style={{ display: 'flex', gap: '4px', marginBottom: '16px', background: '#080d14', borderRadius: '10px', padding: '4px' }}>
          {['partidos','posiciones','especiales'].map(v => (
            <button key={v} onClick={() => setVista(v)} style={{ flex: 1, padding: '8px', border: 'none', borderRadius: '7px', cursor: 'pointer', fontWeight: 'bold', fontSize: '0.78rem', background: vista === v ? '#1e293b' : 'transparent', color: vista === v ? (v === 'especiales' ? '#fbbf24' : '#fff') : '#f6f8fa' }}>
              {v === 'partidos' ? ' Partidos' : v === 'posiciones' ? ' Posiciones' : ' Especiales'}
            </button>
          ))}
        </div>

        {vista === 'partidos' && (
          <>
            {/* Banner importar pronósticos de otro prode */}
            {otroProdeCon && !bloqueado && (
              <div style={{
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                gap: '10px', background: '#0f1f35', border: '1px solid #00f2ff33',
                borderRadius: '10px', padding: '10px 14px', marginBottom: '12px',
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: 0 }}>
                  <span style={{ fontSize: '1.2rem' }}></span>
                  <div>
                    <p style={{ margin: 0, color: '#e2e8f0', fontSize: '0.82rem', fontWeight: 'bold' }}>
                      Tenés {otroProdeCon.count} pronósticos en "{otroProdeCon.nombre}"
                    </p>
                    <p style={{ margin: 0, color: '#64748b', fontSize: '0.72rem' }}>
                      ¿Importarlos a este prode?
                    </p>
                  </div>
                </div>
                <div style={{ display: 'flex', gap: '6px', flexShrink: 0 }}>
                  <button onClick={() => setOtroProdecon(null)}
                    style={{ background: 'transparent', border: '1px solid #1e293b', borderRadius: '6px', padding: '5px 10px', color: '#f6f8fa', fontSize: '0.72rem', cursor: 'pointer' }}>
                    No
                  </button>
                  <button onClick={importarPronosticos} disabled={importando}
                    style={{ background: '#00f2ff', border: 'none', borderRadius: '6px', padding: '5px 14px', color: '#000', fontSize: '0.72rem', fontWeight: 'bold', cursor: 'pointer' }}>
                    {importando ? '...' : '✓ Importar'}
                  </button>
                </div>
              </div>
            )}
            {importadoOk && (
              <div style={{ background: '#16a34a22', border: '1px solid #16a34a44', borderRadius: '8px', padding: '8px 14px', marginBottom: '10px', color: '#22c55e', fontSize: '0.8rem', textAlign: 'center' }}>
                ✓ Pronósticos importados correctamente
              </div>
            )}
            {jornadas.length > 1 && (
              <div style={{ display: 'flex', gap: '6px', marginBottom: '12px', overflowX: 'auto', paddingBottom: '4px', WebkitOverflowScrolling: 'touch', scrollbarWidth: 'none' }}>
                {jornadas.map(j => (
                  <button key={j.numero} onClick={() => cambiarJornada(j)} style={{
                    flexShrink: 0, padding: '6px 12px',
                    border: `1px solid ${jornadaActiva?.numero === j.numero ? '#00f2ff' : '#1e293b'}`,
                    borderRadius: '20px', cursor: 'pointer', fontSize: '0.7rem', fontWeight: 'bold',
                    background: jornadaActiva?.numero === j.numero ? '#00f2ff15' : '#080d14',
                    color: jornadaActiva?.numero === j.numero ? '#00f2ff' : '#f6f8fa',
                  }}>
                    {j.nombre}
                  </button>
                ))}
              </div>
            )}

            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px', padding: '8px 12px', background: '#080d14', borderRadius: '8px', border: '1px solid #1e293b' }}>
              <span style={{ color: bloqueado ? '#ff4444' : tiempoCierre ? '#f59e0b' : '#22c55e', fontSize: '0.72rem', fontWeight: 'bold' }}>
                {bloqueado ? ' Los pronósticos están cerrados. Podés ver las predicciones de los demás clickeando cada partido.' : tiempoCierre ? `⏱ ${tiempoCierre}` : '✓ Abierto'}
              </span>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span style={{ color: '#f6f8fa', fontSize: '0.68rem' }}>{completados}/{partidos.length}</span>
                <div style={{ width: '60px', height: '4px', background: '#1e293b', borderRadius: '2px', overflow: 'hidden' }}>
                  <div style={{ width: `${partidos.length ? (completados / partidos.length) * 100 : 0}%`, height: '100%', background: '#f59e0b', transition: '0.3s' }} />
                </div>
              </div>
            </div>

            {partidos.length === 0
              ? <p style={{ color: '#f6f8fa', textAlign: 'center', padding: '40px 0' }}>Sin partidos en esta jornada</p>
              : <>
                  {(() => {
                    const ordenados = [...partidos].sort((a, b) => new Date(a.hora) - new Date(b.hora));
                    const jugados   = ordenados.filter(p => p.goles_local !== null);
                    const pendientes2 = ordenados.filter(p => p.goles_local === null);
                    return (
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                        {pendientes2.map(p => (
                          <PartidoCard key={p.id} partido={p} pronostico={pronosticos[p.id]}
                            onCambio={onCambioPartido} bloqueado={bloqueado}
                            onVerPredicciones={() => abrirModalPredicciones(p)}
                      ultimosResultados={ultimosResultados} />
                        ))}
                        {jugados.length > 0 && (
                          <>
                            <button
                              onClick={() => setMostrarJugados(v => !v)}
                              style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', background: 'transparent', border: '1px solid #1e293b', borderRadius: '8px', padding: '10px 14px', cursor: 'pointer', color: '#64748b', fontSize: '0.75rem', fontWeight: 'bold' }}
                            >
                              <span>Partidos jugados ({jugados.length})</span>
                              <span style={{ fontSize: '0.7rem' }}>{mostrarJugados ? '▲' : '▼'}</span>
                            </button>
                            {mostrarJugados && jugados.map(p => (
                              <PartidoCard key={p.id} partido={p} pronostico={pronosticos[p.id]}
                                onCambio={onCambioPartido} bloqueado={bloqueado}
                                onVerPredicciones={() => abrirModalPredicciones(p)} />
                            ))}
                          </>
                        )}
                      </div>
                    );
                  })()}
                  {!bloqueado && (
                    <button
                      onClick={guardarTodos}
                      disabled={guardandoTodos || Object.keys(pendientes).filter(id => pendientes[id].local !== '' && pendientes[id].visitante !== '').length === 0}
                      style={{
                        marginTop: '6px', width: '100%', padding: '12px',
                        background: guardadoOk ? '#22c55e' : Object.keys(pendientes).filter(id => pendientes[id].local !== '' && pendientes[id].visitante !== '').length > 0 ? '#f59e0b' : '#1e293b',
                        color: Object.keys(pendientes).filter(id => pendientes[id].local !== '' && pendientes[id].visitante !== '').length > 0 || guardadoOk ? '#000' : '#f6f8fa',
                        border: 'none', borderRadius: '10px', fontWeight: 'bold', fontSize: '0.9rem',
                        cursor: Object.keys(pendientes).filter(id => pendientes[id].local !== '' && pendientes[id].visitante !== '').length > 0 ? 'pointer' : 'not-allowed',
                        transition: '0.3s',
                      }}
                    >
                      {guardadoOk ? '✓ Guardado' : guardandoTodos ? 'Guardando...' : `Guardar pronósticos`}
                    </button>
                  )}
                </>
            }
          </>
        )}

        {vista === 'posiciones' && (
          <div>
          <button onClick={async () => {
            if (!posicionesRef.current) return;
            try {
              let h2c = window.html2canvas;
              if (!h2c) {
                await new Promise((res, rej) => {
                  const s = document.createElement('script');
                  s.src = 'https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js';
                  s.onload = res; s.onerror = rej;
                  document.head.appendChild(s);
                });
                h2c = window.html2canvas;
              }
              const canvas = await h2c(posicionesRef.current, { backgroundColor: '#0a0f19', scale: 2, useCORS: true, logging: false });
              const url = canvas.toDataURL('image/png');
              if (navigator.share && navigator.canShare) {
                canvas.toBlob(async (blob) => {
                  const file = new File([blob], `posiciones_${torneo?.nombre || 'prode'}.png`, { type: 'image/png' });
                  if (navigator.canShare({ files: [file] })) {
                    await navigator.share({ files: [file], title: `Posiciones: ${torneo?.nombre || 'Prode'}` });
                  } else {
                    const a = document.createElement('a'); a.href = url; a.download = 'posiciones.png'; a.click();
                  }
                }, 'image/png');
              } else {
                const a = document.createElement('a'); a.href = url; a.download = 'posiciones.png'; a.click();
              }
            } catch(e) { console.error(e); }
          }}
            style={{ width:'100%', marginBottom:'10px', padding:'9px', background:'transparent', border:'1px solid #1e293b', borderRadius:'8px', color:'#64748b', fontSize:'0.78rem', cursor:'pointer', fontWeight:'bold' }}>
            Compartir tabla
          </button>
          <div ref={posicionesRef} style={{ background: '#080d14', borderRadius: '12px', overflow: 'hidden', border: '1px solid #1e293b', padding: '12px' }}>
            <p style={{ color: '#f59e0b', fontWeight: 'bold', fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '1px', margin: '0 0 10px', textAlign: 'center' }}>{torneo?.nombre}</p>
          <div style={{ background: '#080d14', borderRadius: '12px', overflow: 'hidden', border: '1px solid #1e293b' }}>
            <div style={{ display: 'grid', gridTemplateColumns: '40px 1fr 70px 60px', padding: '10px 16px', borderBottom: '1px solid #1e293b' }}>
              <span style={{ color: '#f6f8fa', fontSize: '0.7rem' }}>#</span>
              <span style={{ color: '#f6f8fa', fontSize: '0.7rem' }}>JUGADOR</span>
              <span style={{ color: '#3b82f6', fontSize: '0.7rem', textAlign: 'center' }}>PLENOS</span>
              <span style={{ color: '#f6f8fa', fontSize: '0.7rem', textAlign: 'right' }}>PUNTOS</span>
            </div>
            {tabla.map((p, i) => (
              <div key={i} style={{ display: 'grid', gridTemplateColumns: '40px 1fr 70px 60px', padding: '12px 16px', borderBottom: i < tabla.length - 1 ? '1px solid #0f172a' : 'none', background: p.user_id === session.user.id ? '#f59e0b0d' : 'transparent' }}>
                <span style={{ color: i === 0 ? '#f59e0b' : i === 1 ? '#f6f8fa' : i === 2 ? '#b45309' : '#f6f8fa', fontWeight: 'bold' }}>
                  {i === 0 ? '🥇' : i === 1 ? '🥈' : i === 2 ? '🥉' : `#${i+1}`}
                </span>
                <span style={{ color: p.user_id === session.user.id ? '#f59e0b' : '#e2e8f0', fontWeight: p.user_id === session.user.id ? 'bold' : 'normal' }}>
                  {p.nombre_usuario}

                </span>
                <span style={{ textAlign: 'center', color: '#3b82f6', fontWeight: 'bold', fontSize: '0.82rem' }}>
                  {p.plenos > 0 ? p.plenos : <span style={{ color: '#1e293b' }}>—</span>}
                </span>
                <span style={{ textAlign: 'right', fontWeight: 'bold', color: '#f59e0b' }}>{p.puntos_totales}</span>
              </div>
            ))}
          </div>
          </div>
          </div>
        )}

        {vista === 'especiales' && (
          <div>
            <div style={{ background: '#080d14', border: '1px solid #f59e0b33', borderRadius: '12px', padding: '16px 18px', marginBottom: '12px' }}>
              <p style={{ color: '#fbbf24', fontWeight: 'bold', fontSize: '0.95rem', margin: '0 0 4px' }}>Predicciones Especiales</p>
              <p style={{ color: '#f6f8fa', fontSize: '0.8rem', margin: '0 0 12px' }}>Acertá cada predicción y sumá <strong style={{ color: '#fbbf24' }}>15 pts</strong>. Se revelan cuando el torneo finaliza.</p>

              {predEspecialesBloqueadas && !torneo?.finalizado && (
                <div style={{ background: '#1e293b', borderRadius: '8px', padding: '8px 12px', marginBottom: '12px', color: '#f6f8fa', fontSize: '0.8rem', display: 'flex', alignItems: 'center', gap: '6px' }}>
                   Las predicciones especiales están cerradas. Los resultados se revelarán al finalizar el torneo.
                </div>
              )}

              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                {[
                  { key: 'campeon',       label: 'Campeón del mundo',   tipo: 'pais' },
                  { key: 'subcampeon',    label: 'Subcampeón',          tipo: 'pais' },
                  { key: 'max_goleador',  label: 'Máximo goleador',     tipo: 'jugador' },
                  { key: 'max_asistidor', label: 'Máximo asistidor',    tipo: 'jugador' },
                ].map(({ key, label, tipo }) => (
                  <EspecialAutocomplete
                    key={key}
                    label={label}
                    tipo={tipo}
                    value={predEspecial[key]}
                    onChange={val => { setPredGuardada(false); setPredEspecial(prev => ({ ...prev, [key]: val })); }}
                    finalizado={predEspecialesBloqueadas}
                    valorReal={torneo?.finalizado ? torneo?.[`${key}_real`] : null}
                  />
                ))}
              </div>

              {!predEspecialesBloqueadas && (
                <button
                  onClick={async () => {
                    setGuardandoPred(true);
                    await supabase.from('prode_predicciones_especiales').upsert({
                      torneo_id: torneoId, user_id: session.user.id, ...predEspecial
                    }, { onConflict: 'torneo_id,user_id' });
                    setGuardandoPred(false);
                    setPredGuardada(true);
                  }}
                  disabled={guardandoPred}
                  style={{ marginTop: '14px', padding: '10px 24px', background: predGuardada ? '#22c55e22' : '#f59e0b22', border: `1px solid ${predGuardada ? '#22c55e' : '#f59e0b'}`, borderRadius: '8px', color: predGuardada ? '#86efac' : '#fbbf24', fontWeight: 'bold', cursor: 'pointer', fontSize: '0.9rem' }}>
                  {guardandoPred ? '⏳ Guardando...' : predGuardada ? '✓ Guardado' : '💾 Guardar predicciones'}
                </button>
              )}
            </div>

            {torneo?.finalizado && (
              <div style={{ background: '#22c55e10', border: '1px solid #22c55e33', borderRadius: '10px', padding: '14px 16px', textAlign: 'center' }}>
                <p style={{ color: '#86efac', fontWeight: 'bold', margin: 0 }}> Torneo finalizado</p>
              </div>
            )}

            {especialesOtros.length > 0 && (
              <div style={{ background: '#080d14', border: '1px solid #1e293b', borderRadius: '12px', padding: '16px 18px', marginTop: '12px' }}>
                <p style={{ color: '#fbbf24', fontWeight: 'bold', fontSize: '0.85rem', margin: '0 0 12px', textTransform: 'uppercase', letterSpacing: '1px' }}>
                  Predicciones de todos
                </p>
                {[
                  { key: 'campeon',       label: 'Campeón' },
                  { key: 'subcampeon',    label: 'Subcampeón' },
                  { key: 'max_goleador',  label: 'Máx. goleador' },
                  { key: 'max_asistidor', label: 'Máx. asistidor' },
                ].map(({ key, label }) => (
                  <div key={key} style={{ marginBottom: '14px' }}>
                    <p style={{ color: '#64748b', fontSize: '0.65rem', textTransform: 'uppercase', letterSpacing: '1px', margin: '0 0 6px' }}>{label}</p>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                      {especialesOtros.map((e, i) => (
                        <div key={i} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '6px 10px', borderLeft: `2px solid ${e.user_id === session.user.id ? '#fbbf24' : '#1e293b'}` }}>
                          <span style={{ color: e.user_id === session.user.id ? '#fbbf24' : '#e2e8f0', fontSize: '0.78rem', fontWeight: e.user_id === session.user.id ? 'bold' : 'normal' }}>
                            {e.nombre_usuario}
                            {e.user_id === session.user.id && <span style={{ color: '#f59e0b', fontSize: '0.55rem', border: '1px solid #f59e0b44', borderRadius: '3px', padding: '0 4px', marginLeft: '5px' }}>vos</span>}
                          </span>
                          <span style={{ color: e[key] ? '#cbd5e1' : '#334155', fontSize: '0.78rem' }}>
                            {e[key] || '—'}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
};// ── Lista de torneos ──────────────────────────────────────────────────────────
const Prode = ({ session }) => {
  const { confirmar, ConfirmModal: ConfirmModalProde } = useConfirm();
  const [searchParams, setSearchParams] = useSearchParams();
  const idInicial = searchParams.get('id');
  const [vista, setVista]               = useState(idInicial ? 'detalle' : 'lista');
  const [torneos, setTorneos]           = useState([]);
  const [torneoActivo, setTorneoActivo] = useState(idInicial || null);

  const [codigo, setCodigo]             = useState('');
  const [nombreNuevo, setNombreNuevo]   = useState('');
  const [loading, setLoading]           = useState(true);
  const [msg, setMsg]                   = useState('');
  const [miNick, setMiNick]             = useState('');
  const [seccion, setSeccion]           = useState('lista');
  const [prodePublico, setProdePublico] = useState(false);
  const [resultadosBusqueda, setResultadosBusqueda] = useState([]);
  const [busqueda, setBusqueda]         = useState('');
  const [buscando, setBuscando]         = useState(false);
  const [uniendose, setUniendose]       = useState(null);

  useEffect(() => {
    supabase.from('perfiles').select('nickname').eq('id', session.user.id).single()
      .then(({ data }) => setMiNick(data?.nickname || session.user.email.split('@')[0]));
    cargarTorneos();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const id = searchParams.get('id');
    if (id && id !== torneoActivo) { setTorneoActivo(id); setVista('detalle'); }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  const cargarTorneos = async () => {
    const { data } = await supabase.from('prode_participantes')
      .select('*, torneo:prode_torneos(*, clan:clanes!prode_torneos_clan_id_fkey(tag))').eq('user_id', session.user.id);
    // Agregar count de participantes por torneo
    if (data?.length) {
      for (const t of data) {
        const { count } = await supabase.from('prode_participantes')
          .select('*', { count: 'exact', head: true }).eq('torneo_id', t.torneo.id);
        t.torneo._participantes = count || 0;
      }
    }
    setTorneos(data || []);
    setLoading(false);
  };

  const abandonarProde = async (e, torneoId) => {
    e.stopPropagation();
    const ok = await confirmar({ mensaje: '¿Abandonar este torneo prode?', textoOk: 'Abandonar', peligro: true });
    if (!ok) return;
    await supabase.from('prode_participantes').delete()
      .eq('torneo_id', torneoId).eq('user_id', session.user.id);
    // Si quedó vacío → eliminar completamente
    const { count } = await supabase.from('prode_participantes')
      .select('*', { count: 'exact', head: true }).eq('torneo_id', torneoId);
    if (count === 0) {
      await supabase.from('prode_predicciones_especiales').delete().eq('torneo_id', torneoId);
      await supabase.from('prode_pronosticos').delete().eq('torneo_id', torneoId);
      await supabase.from('prode_torneos').delete().eq('id', torneoId);
    }
    setTorneos(prev => prev.filter(t => t.torneo.id !== torneoId));
  };

  const borrarProde = async (e, torneoId) => {
    e.stopPropagation();
    const ok = await confirmar({ mensaje: '¿Eliminar este torneo prode?', detalle: 'No se puede deshacer.', textoOk: 'Eliminar', peligro: true });
    if (!ok) return;
    await supabase.from('prode_predicciones_especiales').delete().eq('torneo_id', torneoId);
    await supabase.from('prode_pronosticos').delete().eq('torneo_id', torneoId);
    await supabase.from('prode_participantes').delete().eq('torneo_id', torneoId);
    await supabase.from('prode_torneos').delete().eq('id', torneoId);
    setTorneos(prev => prev.filter(t => t.torneo.id !== torneoId));
  };

  const crearTorneo = async () => {
    if (!nombreNuevo.trim()) return;
    const cod = Math.random().toString(36).substring(2, 8).toUpperCase();
    const { data: t } = await supabase.from('prode_torneos').insert({
      nombre: nombreNuevo, creador_id: session.user.id, codigo_invitacion: cod,
      puntos_resultado_exacto: 5, puntos_resultado_parcial: 2, puntos_diferencia: 3,
      publico: prodePublico,
    }).select().single();
    if (t) {
      await supabase.from('prode_participantes').insert({ torneo_id: t.id, user_id: session.user.id, nombre_usuario: miNick });
      setNombreNuevo(''); setTorneoActivo(t.id); setSearchParams({ id: t.id }); setVista('detalle');
    }
  };

  const unirse = async () => {
    const { data: t } = await supabase.from('prode_torneos').select('*').eq('codigo_invitacion', codigo.toUpperCase()).single();
    if (!t) { setMsg('Código inválido'); return; }
    const { error } = await supabase.from('prode_participantes').insert({ torneo_id: t.id, user_id: session.user.id, nombre_usuario: miNick });
    if (error?.code === '23505') { setMsg('Ya estás en este torneo'); return; }
    setCodigo(''); setTorneoActivo(t.id); setSearchParams({ id: t.id }); setVista('detalle');
  };

  const buscarProdes = async (texto) => {
    setBusqueda(texto); setBuscando(true);
    try {
      let query = supabase.from('prode_torneos')
        .select('id, nombre, creador_id, created_at').eq('publico', true)
        .order('created_at', { ascending: false }).limit(20);
      if (texto.trim()) query = query.ilike('nombre', `%${texto}%`);
      const { data } = await query;
      if (!data?.length) { setResultadosBusqueda([]); setBuscando(false); return; }
      const results = await Promise.all(data.map(async (t) => {
        const [{ count }, { data: creador }] = await Promise.all([
          supabase.from('prode_participantes').select('*', { count: 'exact', head: true }).eq('torneo_id', t.id),
          supabase.from('perfiles').select('nickname').eq('id', t.creador_id).maybeSingle(),
        ]);
        const { count: yaEsta } = await supabase.from('prode_participantes')
          .select('*', { count: 'exact', head: true }).eq('torneo_id', t.id).eq('user_id', session.user.id);
        return { ...t, participantes: count || 0, creador_nick: creador?.nickname || '?', yaEsta: yaEsta > 0 };
      }));
      setResultadosBusqueda(results);
    } catch(e) { console.error(e); }
    finally { setBuscando(false); }
  };

  const unirseDirecto = async (torneoId) => {
    setUniendose(torneoId);
    try {
      await supabase.from('prode_participantes').insert({ torneo_id: torneoId, user_id: session.user.id, nombre_usuario: miNick });
      setTorneoActivo(torneoId); setSearchParams({ id: torneoId }); setVista('detalle');
    } catch(e) { console.error(e); }
    finally { setUniendose(null); }
  };

  if (vista === 'detalle' && torneoActivo) {
    return <ProdeDetalle torneoId={torneoActivo} session={session}
      onVolver={() => { setVista('lista'); setTorneoActivo(null); setSearchParams({}); cargarTorneos(); }} />;
  }

  return (
    <div style={{ maxWidth: '860px', margin: '0 auto', padding: '24px 20px', color: 'white' }}>
      <h1 style={{ margin: '0 0 4px', fontSize: '1.6rem' }}>Prode </h1>
      <p style={{ color: '#f6f8fa', margin: '0 0 20px', fontSize: '0.85rem' }}>Predecí los resultados y competí con tus amigos</p>

      <div style={{ display: 'flex', gap: '10px', marginBottom: '20px', flexWrap: 'wrap' }}>
        {[
          { key: 'lista',  label: ' Mis torneos' },
          { key: 'crear',  label: '+ Crear' },
          { key: 'buscar', label: ' Buscar torneos' },
        ].map(({ key, label }) => (
          <button key={key} onClick={() => { setSeccion(seccion === key ? 'lista' : key); setMsg(''); if (key === 'buscar') buscarProdes(''); }}
            style={{ padding: '8px 16px', borderRadius: '8px', fontWeight: 'bold', fontSize: '0.85rem', cursor: 'pointer', transition: '0.2s',
              background: seccion === key ? '#f59e0b' : 'transparent',
              color: seccion === key ? '#000' : '#f59e0b', border: '1px solid #f59e0b' }}>
            {label}
          </button>
        ))}
      </div>

      {seccion === 'crear' && (
        <div style={{ background: '#080d14', border: '1px solid #f59e0b44', borderRadius: '12px', padding: '20px', marginBottom: '24px', display: 'flex', gap: '10px', flexWrap: 'wrap', alignItems: 'flex-start' }}>
          <input value={nombreNuevo} onChange={e => setNombreNuevo(e.target.value)} placeholder="Nombre del torneo"
            style={{ flex: 1, minWidth: '200px', background: '#0a0f19', border: '1px solid #1e293b', borderRadius: '8px', padding: '9px 12px', color: '#fff', fontSize: '0.9rem' }} />
          <button onClick={() => setProdePublico(v => !v)}
            style={{ padding: '9px 14px', background: prodePublico ? '#22c55e22' : '#1a2233', color: prodePublico ? '#22c55e' : '#64748b', border: `1px solid ${prodePublico ? '#22c55e55' : '#333'}`, borderRadius: '8px', cursor: 'pointer', fontSize: '0.82rem', whiteSpace: 'nowrap' }}>
            {prodePublico ? ' Público' : ' Privado'}
          </button>
          <button onClick={crearTorneo} style={{ padding: '9px 20px', background: '#f59e0b', color: '#000', border: 'none', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer' }}>Crear</button>
        </div>
      )}

      {seccion === 'buscar' && (
        <div style={{ background: '#080d14', border: '1px solid #f59e0b44', borderRadius: '12px', padding: '20px', marginBottom: '24px' }}>
          <p style={{ color: '#f59e0b', fontSize: '0.7rem', textTransform: 'uppercase', letterSpacing: '1px', margin: '0 0 8px' }}>Unirse con código</p>
          <div style={{ display: 'flex', gap: '8px', marginBottom: '20px' }}>
            <input value={codigo} onChange={e => setCodigo(e.target.value.toUpperCase())} placeholder="Código de invitación"
              style={{ flex: 1, background: '#0a0f19', border: '1px solid #1e293b', borderRadius: '8px', padding: '9px 12px', color: '#fff', fontSize: '0.9rem', fontFamily: 'monospace', letterSpacing: '1px' }} />
            <button onClick={unirse} style={{ padding: '9px 18px', background: '#f59e0b', color: '#000', border: 'none', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer', whiteSpace: 'nowrap' }}>Unirse</button>
          </div>
          {msg && <p style={{ color: '#ff4444', fontSize: '0.8rem', margin: '-12px 0 12px' }}>{msg}</p>}
          <p style={{ color: '#f59e0b', fontSize: '0.7rem', textTransform: 'uppercase', letterSpacing: '1px', margin: '0 0 8px' }}>Torneos públicos</p>
          <input value={busqueda} onChange={e => buscarProdes(e.target.value)} placeholder="Filtrar por nombre..."
            style={{ width: '100%', background: '#0a0f19', border: '1px solid #1e293b', borderRadius: '8px', padding: '9px 12px', color: '#fff', fontSize: '0.9rem', boxSizing: 'border-box', marginBottom: '16px' }} />
          {buscando && <p style={{ color: '#f6f8fa', fontSize: '0.8rem' }}>Buscando...</p>}
          {!buscando && resultadosBusqueda.length === 0 && busqueda && <p style={{ color: '#f6f8fa', fontSize: '0.8rem' }}>Sin resultados</p>}
          {resultadosBusqueda.length > 0 && (
            <>
              <p style={{ color: '#f59e0b', fontSize: '0.7rem', textTransform: 'uppercase', letterSpacing: '1px', margin: '0 0 12px' }}>Podés unirte a estos torneos públicos</p>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', gap: '10px' }}>
                {resultadosBusqueda.map(t => (
                  <div key={t.id} style={{ padding: '14px', background: '#0a0f19', border: '1px solid #1e293b', borderRadius: '10px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    <div>
                      <p style={{ margin: 0, fontWeight: 'bold', color: '#e2e8f0', fontSize: '0.95rem' }}>{t.nombre}</p>
                      <p style={{ margin: '4px 0 0', fontSize: '0.75rem', color: '#f6f8fa' }}>
                        por <span style={{ color: '#94a3b8' }}>{t.creador_nick}</span>
                        <span style={{ margin: '0 6px', color: '#f6f8fa' }}>·</span>
                        <span style={{ color: '#f59e0b' }}>{t.participantes} participante{t.participantes !== 1 ? 's' : ''}</span>
                      </p>
                    </div>
                    {t.yaEsta ? (
                      <button onClick={() => { setTorneoActivo(t.id); setSearchParams({ id: t.id }); setVista('detalle'); }}
                        style={{ padding: '7px', background: 'transparent', color: '#f59e0b', border: '1px solid #f59e0b44', borderRadius: '6px', cursor: 'pointer', fontSize: '0.82rem', fontWeight: 'bold' }}>
                        Ver →
                      </button>
                    ) : (
                      <button onClick={() => unirseDirecto(t.id)} disabled={uniendose === t.id}
                        style={{ padding: '7px', background: '#f59e0b', color: '#000', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '0.82rem', fontWeight: 'bold', opacity: uniendose === t.id ? 0.6 : 1 }}>
                        {uniendose === t.id ? '...' : 'Unirse'}
                      </button>
                    )}
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      )}

      {seccion === 'lista' && (loading ? <Loader texto="Cargando..." /> : (
        <>
          <p style={{ color: '#f6f8fa', fontSize: '0.7rem', textTransform: 'uppercase', letterSpacing: '1px', margin: '0 0 12px' }}>Mis torneos</p>
          {torneos.length === 0
            ? <p style={{ color: '#f6f8fa', fontSize: '0.85rem' }}>No estás en ningún torneo todavía</p>
            : <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {torneos.map((t, i) => (
                  <div key={i} onClick={() => { setTorneoActivo(t.torneo.id); setSearchParams({ id: t.torneo.id }); setVista('detalle'); }}
                    className="prode-card"
                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '14px 16px', background: '#080d14', border: '1px solid #1e293b', borderRadius: '10px', cursor: 'pointer', transition: '0.2s' }}
                    onMouseEnter={e => e.currentTarget.style.borderColor = '#f59e0b'}
                    onMouseLeave={e => e.currentTarget.style.borderColor = '#1e293b'}>
                    <div>
                      <p style={{ color: '#e2e8f0', fontWeight: 'bold', margin: 0 }}>
                        {t.torneo.clan?.tag && (
                          <span style={{ color: '#f59e0b', fontSize: '0.72rem', border: '1px solid #f59e0b55', borderRadius: '4px', padding: '1px 6px', marginRight: '7px', letterSpacing: '1px' }}>[{t.torneo.clan.tag}]</span>
                        )}
                        {t.torneo.nombre}
                      </p>
                      <p style={{ color: '#f6f8fa', fontSize: '0.72rem', margin: '2px 0 0' }}>Código: <span style={{ color: '#f6f8fa' }}>{t.torneo.codigo_invitacion}</span></p>
                    </div>
                    <div className="prode-card-actions" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      {t.torneo.creador_id === session.user.id && (t.torneo._participantes || 0) <= 1 ? (
                        // Creador solo → Borrar
                        <button onClick={(e) => borrarProde(e, t.torneo.id)}
                          style={{ background: '#ef444422', border: '1px solid #ef444444', borderRadius: '6px', padding: '4px 10px', color: '#ef4444', fontSize: '0.75rem', cursor: 'pointer', fontWeight: 'bold' }}>
                          ✕ Borrar
                        </button>
                      ) : (
                        // Creador con gente o participante → Salir
                        <button onClick={(e) => abandonarProde(e, t.torneo.id)}
                          style={{ background: '#f59e0b22', border: '1px solid #f59e0b44', borderRadius: '6px', padding: '4px 10px', color: '#f59e0b', fontSize: '0.75rem', cursor: 'pointer', fontWeight: 'bold' }}>
                          ← Salir
                        </button>
                      )}
                      <span style={{ color: '#f59e0b', fontWeight: 'bold', fontSize: '1.1rem' }}>{t.puntos_totales} pts</span>
                    </div>
                  </div>
                ))}
              </div>
          }
        </>
      ))}
      <Tutorial tutorialId="prode" userId={session?.user?.id} pasos={TUTORIALES.prode} botonVerDeNuevo={true} />
    </div>
  );
};

export default Prode;